import AppSetting from 'pages/AppSetting/AppSetting'
import {
  CREATE_MAGAZINE,
  HOME,
  LOGIN,
  MAINTENANCE,
  SETTING_APP,
  SETTING_BANNER,
  SETTING_MAGAZINE_CATEGORY,
  SETTING_MAGAZINE_SELL_ONCE,
  SETTING_MAGAZINE_SUBCRIBE,
  SETTING_NOTIFICATION,
  SETTING_SUBSCRIBER_ID,
  SETTING_USER
} from '../configs/path'
import { routerType } from '../models/common'
import { lazy } from 'react'

const LoginPage = lazy(() => import('pages/Login/Login'))
const Home = lazy(() => import('pages/Home/HomePage'))
const CreateAppMagazine = lazy(() => import('pages/CreateAppMagazine/CreateAppMagazine'))
const UserSetting = lazy(() => import('pages/UserSetting/UserSetting'))
const NotificationSetting = lazy(() => import('pages/NotificationSetting/NotificationSetting'))
const MagazineSubcribeSetting = lazy(() => import('pages/MagazineSubcribe/MagazineSubcribe'))
const MagazineSellOnceSetting = lazy(() => import('pages/MagazineSellOnce/MagazineSellOnce'))
const MagazineCategorySetting = lazy(() => import('pages/MagazineCategory/MagazineCategory'))
const BannerSetting = lazy(() => import('pages/BannerSetting/BannerSetting'))
const SubscriberIdSetting = lazy(() => import('pages/SubscriberIdSetting/SubscriberIdSetting'))
const MaintenancePage = lazy(() => import('pages/Maintenance/Maintenance'))


export const publicRouter: routerType[] = [
  {
    path: LOGIN,
    element: <LoginPage />
  },
  {
    path: MAINTENANCE,
    element: <MaintenancePage />
  },
]

export const privateRouter: routerType[] = [
  {
    path: HOME,
    element: <Home />
  },
  {
    path: CREATE_MAGAZINE,
    element: <CreateAppMagazine />
  },
  {
    path: SETTING_USER,
    element: <UserSetting />
  },
  {
    path: SETTING_NOTIFICATION,
    element: <NotificationSetting />,
    layoutSetting: true
  },
  {
    path: SETTING_MAGAZINE_SUBCRIBE,
    element: <MagazineSubcribeSetting />,
    layoutSetting: true
  },
  {
    path: SETTING_MAGAZINE_SELL_ONCE,
    element: <MagazineSellOnceSetting />,
    layoutSetting: true
  },
  {
    path: SETTING_MAGAZINE_CATEGORY,
    element: <MagazineCategorySetting />
  },
  {
    path: SETTING_BANNER,
    element: <BannerSetting />,
    layoutSetting: true
  },
  {
    path: SETTING_SUBSCRIBER_ID,
    element: <SubscriberIdSetting />,
    layoutSetting: true
  },
  {
    path: SETTING_APP,
    element: <AppSetting />,
    layoutSetting: true
  }
]
